import {GameStateEnums} from '../../../../../../shared/GameEnums'
import {UIGameMechanic} from '../../UIGameEventController'
import {UIGameManager} from '../../UIGameManager'
import {BeginnerModeConstants, HiddenUIElement, getWaitMSForAction} from '@colonist/game-beginner-mode'
import {BankTransactionLedger, BeginnerModeActionState} from '@colonist/game-state-types'
import {CardView} from '../../../ui_canvas_engine/CardView'
import {FloatingText} from '../../../game_ui_view_objects/FloatingText'
import {GameAction} from '@colonist/game-base-types'
import {CardDataController} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export class UIGameBeginnerModeCardsHelper implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private _shouldCardsFlyToRobber: boolean = false
    private _cardFlyAnimationWaitMS: number = 500

    private _areCardsBeingDealt: boolean = false

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }

    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.BeginnerModeActionUpdated: this.onBeginnerModeActionUpdate(data); break
            case UIGameEventEnums.BeginnerModeInteractWithGuide: this.onBeginnerModeInteractWithGuide(data); break
            case UIGameEventEnums.GivePlayerCardFromTile: this._areCardsBeingDealt = true; break
            case UIGameEventEnums.CardAnimationEnd: this._areCardsBeingDealt = false; break
            default: break
        }
    }

    get shouldCardsFlyToRobber() {
        return this._shouldCardsFlyToRobber
    }

    get cardFlyAnimationWaitMS() {
        return this._cardFlyAnimationWaitMS
    }

    get areCardsBeingDealt() {
        return this._areCardsBeingDealt
    }

    private onBeginnerModeActionUpdate(data: BeginnerModeActionState) {
        const isBankHidden = data.hiddenUIElements.includes(HiddenUIElement.Bank)
        this._shouldCardsFlyToRobber = isBankHidden
        this._cardFlyAnimationWaitMS = getWaitMSForAction(BeginnerModeConstants.BASE_WAIT_MS_FOR_CARD_FLY_ANIMATION, data.actionIndex)
        this.updateDevCardClickActionForBeginnerMode()
    }

    private onBeginnerModeInteractWithGuide(data: BeginnerModeActionState) {
        if(data.type != GameAction.ClickedDevelopmentCard) return
        this.uiGameManager.cardController.cardContainerView.flickerAllCardsOfType([CardEnum.RoadBuilding, CardEnum.Knight])
    }

    updateDevCardClickActionForBeginnerMode() {
        const devCards: CardView[] = []
        for(const card of this.uiGameManager.cardController.cardContainerView.cardInventory.cardViews) {
            if(card.cardData.cardTypeEnum != CardTypeEnum.Development) continue
            if(card.cardData.cardEnum == CardEnum.VictoryPoint) continue
            devCards.push(card)
        }

        const validClickAction = (card: CardView) => card.tappedPlayerCard()
        const displayErrorText = (card: CardView) => new FloatingText({key: 'strings:game.errors.finishCurrentAction'}, card)
        for(const card of devCards) {
            card.view.removeAllListeners()
            card.view.setClickAction(() => {
                const isDiceState = this.uiGameManager.gameController.currentState.turnState == TurnState.Dice
                isDiceState ? displayErrorText(card) : validClickAction(card)
            })
        }
    }

    addPendingCardsToMyCurrentCardEnums(myCurrentCardEnums: CardEnum[], cardsToBeAddedFromTile: BankTransactionLedger[]) {
        const myColor = this.uiGameManager.gameController.myColor
        for(const transaction of cardsToBeAddedFromTile) {
            if(transaction.owner != myColor) continue
            myCurrentCardEnums.push(transaction.card)
        }
        myCurrentCardEnums.sort()
    }

    removeCardsClickActionForBeginnerMode() {
        const cardViews = this.uiGameManager.cardController.cardContainerView.cardInventory.cardViews
        for(const card of cardViews) {
            if(!CardDataController.isResourceCard(card.cardData.cardEnum)) continue
            card.view.removeClickAction()
            card.view.setClickAction(() => this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.BeginnerModeClickedDisabledElement))
        }
    }

    setCardClickActionForBeginnerMode(card: CardView) {
        this.removeCardsClickActionForBeginnerMode()

        const isResourceOrKnightCard = CardDataController.isResourceCard(card.cardData.cardEnum) || card.cardData.cardEnum == CardEnum.Knight
        if(isResourceOrKnightCard) return

        this.updateDevCardClickActionForBeginnerMode()
    }
}
